import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from '../../styles/cr.module.scss';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { SignOffType } from '../../refData/SignOffType';
import { useParams } from 'react-router-dom';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { CrCommandBar } from '../cr/CrCommandBar';
import { SignOffList } from '../signOff/SignOffList';
import { SignOffPageSettings } from '../project/SignOffPageSettings';
import { Period } from '../../refData/Period';
import { DataContext } from '../DataContext';
import { IEntityDescription1 } from '../../types';

interface PortfolioSignOffProps extends IWithErrorHandlingProps {
    lastDirectorateIdForChilds?: number;
    apiConnected: boolean;
    emphasiseProjectsWithCustomField: string;
    emphasisedProjectsHeaderText: string;
    otherProjectsHeaderText: string;

    lastObjectiveIdForChilds?: number | null;
    setLastObjectiveIdForChilds?: React.Dispatch<React.SetStateAction<number | null>>;
    onEntityDescriptionChange: (desc: IEntityDescription1) => void;
}

const PortfolioSignOff = (props: PortfolioSignOffProps) => {

    const { dataServices: { portfolioService, reportDueDatesService } } = useContext(DataContext);
    const [showOptionsAndSettings, setShowOptionsAndSettings] = useState<boolean>(false);
    const [updatePeriod, setUpdatePeriod] = useState<Date>(null);
    const [uniqueUpdatePeriods, setUniqueUpdatePeriods] = useState<Date[]>(null);
    const [showPreviousUpdate, setShowPreviousUpdate] = useState<string>('false');
    const [selectedReportPeriod, setSelectedReportPeriod] = useState<Period>(Period.Current);
    const { portfolioIdForUpdates } = useParams<{ portfolioIdForUpdates: string }>();
    const { requestUpdatePeriod } = useParams<{ requestUpdatePeriod: string }>();

    useEffect(() => {
        setUpdatePeriod(new Date(requestUpdatePeriod));
    }, [requestUpdatePeriod]);

    useEffect(() => {
        const getUniqueDates = async () => {
            if (Number(portfolioIdForUpdates) > 0) {
                const uniqueDates = await reportDueDatesService.getPortfolioUpdateUniqueDates(Number(portfolioIdForUpdates));
                setUniqueUpdatePeriods(uniqueDates);
            }
        }
        getUniqueDates();

        portfolioService.readTitleForPortfolio('Portfolio Updates', 'Portfolio Update', Number(portfolioIdForUpdates)).then(ed => {
            props.onEntityDescriptionChange(ed);
        });

    }, [portfolioIdForUpdates]);

    const history = useHistory();

    const commandBarItems: ICommandBarItemProps[] = [
        {
            key: 'portfolios',
            text: 'Back to Portfolios',
            iconProps: { iconName: 'Back' },
            onClick: (ev, item) => {
                if (props.lastObjectiveIdForChilds != null) {
                    history.push(`/a2/portfolios-for-objective/${props.lastObjectiveIdForChilds}`);
                }
                else {
                    history.push('/a2/portfolios');
                }
            },
        },
        {
            key: 'OptionsSettings',
            text: 'Options & Settings',
            iconProps: { iconName: 'MiniExpand' },
            onClick: (ev, item) => {
                console.log('options popup');
                setShowOptionsAndSettings(true);
            },
        },

    ];

    const handleChangeShowPreviousUpdate = (value: string) => {
        setShowPreviousUpdate(value);
    }

    const handleChangeSelectedPeriod = (period: Period) => {
        if (period === Period.Current || period === Period.Previous) {
            setUpdatePeriod(null);
        }
        setSelectedReportPeriod(period);

    }

    const handleChangeUpdatePeriod = (dateVal: Date) => {
        if (selectedReportPeriod === Period.Specific) {
            setUpdatePeriod(dateVal);
        }
        else {
            setUpdatePeriod(null);
        }
    }


    return (

        <div className={`${styles.updatesContainer}`}>
            <CrCommandBar items={commandBarItems} />
            <div>
                <SignOffList
                    defaultReportType={SignOffType.Portfolio}
                    defaultEntityId={Number(portfolioIdForUpdates)}
                    {...props}
                />
            </div>
            <SignOffPageSettings
                showForm={showOptionsAndSettings}
                showPeriodSelection={true}
                onClosed={() => setShowOptionsAndSettings(false)}
                showPreviousUpdate={showPreviousUpdate}
                onChangeShowPreviousUpdate={handleChangeShowPreviousUpdate}
                reportPeriod={selectedReportPeriod}
                onChangePeriod={handleChangeSelectedPeriod}
                uniqueUpdatePeriods={uniqueUpdatePeriods}
                updatePeriod={updatePeriod}
                onChangeUpdatePeriod={handleChangeUpdatePeriod}
            />
        </div>

    );
};

export default withErrorHandling(PortfolioSignOff);